import * as React from 'react';
import { Switch } from '@sm/smapply-ui';
import Value from './model/value';


/**
 * This class is to wrap a checkbox (in this case a SMApply UI switch component) around a
 * `Value` class.  This is to abstract the logic of setting and getting the internal value of
 * this class away from the element using it.
 *
 * @export
 * @class Checkbox
 * @extends {React.Component}
 */
export class Checkbox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			name: props.name,
			label: props.label,
			value: props.value
		};
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleInputChange() {
		const newValue = new Value(!this.state.value.get());
		this.setState({
			value: newValue
		});

		const returnEvent = {
			target: {
				name: this.state.name,
				value: newValue
			}
		};
		this.props.change(returnEvent);
	}

	render() {
		return (
			<React.Fragment>
				<label className="col-sm-8">
					<strong className="inline">
						{this.state.label}
					</strong>
				</label>
				<div className="col-sm-4 sma-js-toggle-field">
					<Switch	checked={this.state.value.get()} onChange={this.handleInputChange}>
					</Switch>
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.fs/surveys/form-fields/Checkbox.jsx